import React, { useCallback, useEffect, useState } from 'react';
import { LoginFormButton } from '@/components/LoginForm/LoginFormButton';
import { LoginFormTextField } from '@/components/LoginForm/LoginFormTextField';
import { CloudId } from '@/models/domain/CloudId';

type Props = {
    cloudId?: CloudId;
    onClickSSOButton: (cloudId: CloudId) => void;
};

export const SSOLoginForm: React.FC<Props> = (props) => {
    const { cloudId: inputCloudId, onClickSSOButton } = props;
    const [cloudId, setCloudId] = useState<CloudId | undefined>(inputCloudId);
    const [cloudIdErrorMessage, setCloudIdErrorMessage] = useState<string>('');

    useEffect(() => {
        // propsで渡ってくるcloudIdはusecase経由でrepositoryから取得しており、
        // 取得できたら変更される事があるため、変化があったら更新を行う。
        setCloudId(inputCloudId);
    }, [inputCloudId]);

    const onInputCloudId = useCallback((inputValue: string) => {
        setCloudId(new CloudId({ value: inputValue }));
    }, []);

    const onChangeCloudId = useCallback((inputValue: string) => {
        const result = CloudId.RULES.find((rule) => {
            return rule(inputValue) !== true;
        });

        if (result && inputValue) {
            setCloudIdErrorMessage(result(inputValue) as string);
        } else {
            setCloudIdErrorMessage('');
        }
    }, []);

    const handleClickSSOButton = useCallback(() => {
        // 設定値のバリデーションメッセージを格納する
        if (cloudId) {
            setCloudIdErrorMessage(cloudId.validationMessage);
        }

        // 設定値のバリデーションチェックを行う
        if (!cloudId || !cloudId.isValid) {
            return;
        }
        onClickSSOButton(cloudId);
    }, [cloudId, onClickSSOButton]);

    return (
        <div>
            <LoginFormTextField
                errorMessage={cloudIdErrorMessage}
                keepMessageSpace
                label="クラウドID"
                value={cloudId?.value || ''}
                onChange={onChangeCloudId}
                onInput={onInputCloudId}
            />
            <LoginFormButton onClick={handleClickSSOButton}>シングルサインオン</LoginFormButton>
        </div>
    );
};
